export default __webpack_public_path__ + "static/media/EllipseRight.c46d2773.png";